// src/utils/notifications.js
import { toast } from "sonner";

// Helper para reproducir el efecto de sonido
// Helper para reproducir el sonido N veces seguidas
export const playNotificationSound = (repeatCount = 3) => {
    try {
        const audio = new Audio("/sounds/notification.mp3");
        audio.volume = 0.6; // Volumen de 0.0 a 1.0

        let timesPlayed = 0;

        // Escuchamos el evento 'ended' que se dispara cuando el audio termina de sonar
        const handleEnded = () => {
            timesPlayed++;
            
            if (timesPlayed < repeatCount) {
                audio.currentTime = 0; // Regresa el audio al inicio
                audio.play().catch((err) => console.warn("Error al repetir sonido:", err));
            } else {
                // Una vez alcanzado el límite de repeticiones, removemos el listener
                audio.removeEventListener("ended", handleEnded);
            }
        };

        audio.addEventListener("ended", handleEnded);

        // Reproducción inicial
        audio.play().catch((error) => {
            console.warn("No se pudo reproducir el sonido automáticamente:", error);
        });
    } catch (error) {
        console.error("Error al inicializar el sonido de notificación:", error);
    }
};

export const requestNotificationPermission = async () => {
    if (!("Notification" in window)) {
        console.warn("Este navegador no soporta notificaciones de escritorio.");
        return false;
    }

    if (Notification.permission === "granted") {
        return true;
    }

    if (Notification.permission !== "denied") {
        const permission = await Notification.requestPermission();
        return permission === "granted";
    }

    return false;
};

export const triggerTaskReminder = (task) => {
    const title = `⏰ Recordatorio: ${task.name}`;
    const body = task.description || "Tienes una tarea programada para este momento.";

    // 1. REPRODUCIR SONIDO
    playNotificationSound(2);

    // 2. NOTIFICACIÓN NATIVA DEL SISTEMA
    if ("Notification" in window && Notification.permission === "granted") {
        try {
            new Notification(title, {
                body: body,
                icon: "/favicon.ico",
                tag: `task-reminder-${task.id}`,
            });
        } catch (error) {
            console.error("Error al lanzar la notificación nativa:", error);
        }
    }

    // 3. TOAST FLOTANTE CON SONNER
    toast.info(title, {
        description: body,
        duration: 10000,
        action: {
            label: "Ver Tarea",
            onClick: () => console.log("Tarea seleccionada:", task.id),
        },
    });
};